import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { isExternalHref } from '@/lib/hostRouting'

export default function RouteRedirect({ to }) {
  useEffect(() => {
    if (isExternalHref(to)) {
      window.location.replace(to)
    }
  }, [to])

  if (isExternalHref(to)) {
    return <div className="min-h-screen bg-background" />
  }

  return <Navigate to={to} replace />
}
